import { useId, useState } from "react";

import BottomMobileOptionsModal from "@/components/bottom-mobile-options-modal";
import Timeslots from "@/components/timeslots";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

import type { GameType } from "../types";

function FlashIcon({ className, ...props }: React.ComponentProps<"svg">) {
  const id = useId();

  return (
    <svg
      aria-hidden="true"
      className={cn("h-[23px] w-4.5", className)}
      fill="none"
      viewBox="0 0 18 23"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter={`url(#${id})`}>
        <path
          clipRule="evenodd"
          d="M8.85 3.55l-.19.353a11582.208 11582.208 0 01-2.181 4.03 1657.557 1657.557 0 00-1.627 3.004l-.5.924c-.1.184.039.403.255.404l1.113.002a80.63 80.63 0 011.587.01c0 .005-.048.097-.107.205l-.19.35-.257.475A2178.496 2178.496 0 015.41 15.79a198.728 198.728 0 01-.587 1.084l-.75 1.387-.418.77-.25.46c-.017.028.034-.01.196-.147a468.02 468.02 0 011.352-1.13 2437.694 2437.694 0 012.954-2.472 1724.035 1724.035 0 001.292-1.08 864.54 864.54 0 002.386-1.996l.73-.61 1.303-1.09c.086-.072.033-.208-.08-.208l-1.258-.002a78.965 78.965 0 01-1.585-.011c0-.005.087-.169.193-.365a908.23 908.23 0 00.938-1.73 1990.036 1990.036 0 001.768-3.266l.34-.628.412-.76c.14-.259.255-.476.255-.483 0-.01-.84-.013-2.861-.013H8.936a.097.097 0 00-.085.05z"
          fill="#fff"
          fillRule="evenodd"
        />
      </g>
      <defs>
        <filter
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          height="21.6"
          id={id}
          width="16.8"
          x="0.6"
          y="0.7"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="1.4" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0.929348 0 0 0 0 0.44144 0 0 0 0 0.524009 0 0 0 0.1 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_19179_8546"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_19179_8546"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}

interface BookNowButtonProps {
  game: GameType;
  onClick(): void;
}

export default function BookNowButton({ game, onClick }: BookNowButtonProps) {
  const [isOpen, setIsOpen] = useState(false);

  const handleClick = () => {
    onClick();
    setIsOpen(true);
  };

  return (
    <>
      <Button
        className="flex h-[45px] w-full gap-2.5 rounded-[23px] bg-linear-44 from-tangerine to-bright-pink shadow-persian-red transition-shadow hover:shadow-0-0-10"
        onClick={handleClick}
      >
        <FlashIcon />
        <span className="font-medium text-14 text-white">Book now</span>
      </Button>
      {isOpen && (
        <BottomMobileOptionsModal onOpenChange={setIsOpen} open={isOpen}>
          <Timeslots
            game={game}
            ignoreTimezone={game.kind === "RER"}
            initialView="week"
            isModal
          />
        </BottomMobileOptionsModal>
      )}
    </>
  );
}
